import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { openCsChannel } from "@/shared/lib/csChannel";
import Credit4uDesyncCsSheet from "./Credit4uDesyncCsSheet";

/**
 * 비밀번호 변경 완료 시 홈으로 replace 이동하며 넘긴 nav-state 를 소비해,
 * 홈 화면 위에 DESYNC(CODEF 반영·DB 저장 실패) CS 문의 팝업을 띄운다.
 *
 * Router 레벨(BrowserRouter 안, Routes 밖)에 마운트되어 라우트 전환과 무관하게 렌더된다
 * (AuthSessionRecovery / Credit4uPasswordExpiryRecovery 와 동일 배치).
 */
export const SHOW_DESYNC_CS_ON_RETURN = "showDesyncCsPopupOnReturn";

export type DesyncCsReturnState = {
  [SHOW_DESYNC_CS_ON_RETURN]?: boolean;
} | null;

const Credit4uDesyncCsRecovery = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  // nav-state 플래그를 즉시 소거(뒤로가기/재마운트 재발동 방지)한 뒤 팝업을 연다.
  // 소거로 idempotent — 새 DESYNC 이동이 다시 플래그를 실으면 재발화한다.
  useEffect(() => {
    const state = location.state as DesyncCsReturnState;
    if (state?.[SHOW_DESYNC_CS_ON_RETURN]) {
      navigate(location.pathname, { replace: true, state: {} });
      setIsOpen(true);
    }
  }, [location, navigate]);

  const handleContactCs = () => {
    // ⚠️ 먼저 닫는다 — 외부 앱(카카오톡) 전환으로 suspend 돼도 복귀 시 팝업이 남지 않게(close-first).
    setIsOpen(false);
    openCsChannel(); // 앱 공통 CS 진입점 = 카카오 CS 채널 (#237 로 배선됨)
  };

  return (
    <Credit4uDesyncCsSheet
      isOpen={isOpen}
      onContactCs={handleContactCs}
      onClose={() => setIsOpen(false)}
    />
  );
};

export default Credit4uDesyncCsRecovery;
